import * as React from "react";
import { Navigate, useSearchParams } from "react-router-dom";
import Alert from "react-bootstrap/Alert";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import Form from "react-bootstrap/Form";
import Spinner from "react-bootstrap/Spinner";

import { AuthContext } from "../context";

const Login = () => {
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState<string | null>(null);
  const { setAuth, fetch } = React.useContext(AuthContext);

  const emailRef = React.useRef<HTMLInputElement>(null);
  const tokenRef = React.useRef<HTMLInputElement>(null);

  let initialEmail = "";
  let initialAccessCode = "";

  const [searchParams] = useSearchParams();
  if (searchParams.has("email") && searchParams.has("access-token")) {
    initialEmail = searchParams.get("email")!;
    initialAccessCode = searchParams.get("access-token")!;
  }

  const handleSubmit = React.useCallback(
    (event: React.FormEvent) => {
      event.preventDefault();

      const headers = new Headers({
        Authorization: `Basic ${btoa(
          `${emailRef.current!.value}:${tokenRef.current!.value}`
        )}`,
      });

      void (async () => {
        setLoading(true);

        try {
          const response = await window.fetch("/api/login", {
            method: "POST",
            headers,
          });
          if (response.status === 200) {
            setAuth({
              email: emailRef.current!.value,
              accessToken: tokenRef.current!.value,
            });
          } else {
            setError(((await response.json()) as { error: string }).error);
          }
        } catch (error) {
          setError(String(error));
        } finally {
          setLoading(false);
        }
      })();
    },
    [setAuth]
  );

  if (fetch) {
    let redirect = "/rsvp";
    if (searchParams.has("redirect")) {
      redirect = searchParams.get("redirect")!;
    }

    return <Navigate replace to={redirect} />;
  }

  return (
    <Container className="col-12 col-sm-6">
      <p className="text-light lead">
        Please login to view event details and RSVP.
      </p>
      {error && <Alert variant="danger">{error}</Alert>}
      <Form onSubmit={handleSubmit}>
        <FloatingLabel
          className="mb-3"
          controlId="email-address"
          label="Email address"
        >
          <Form.Control
            defaultValue={initialEmail}
            placeholder="name@example.com"
            ref={emailRef}
            required
            type="email"
          />
        </FloatingLabel>
        <FloatingLabel
          className="mb-4"
          controlId="access-code"
          label="Access code"
        >
          <Form.Control
            defaultValue={initialAccessCode}
            placeholder="access-code"
            ref={tokenRef}
            required
            type="password"
          />
        </FloatingLabel>
        <Button
          className="w-100"
          disabled={loading}
          type="submit"
          variant="primary"
        >
          {loading ? <Spinner animation="border" size="sm" /> : "Login"}
        </Button>
      </Form>
    </Container>
  );
};

export default Login;
